
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-create-waypoint.html
riot.tag2('menu-item-create-waypoint',
  '<i class="material-icons floating-menu_icon">airplay</i> <span class="floating-menu_label">Create Waypoint</span>',
  '',
  'class="{opts.classes} floating-menu_item" onclick="{handleWaypointClick}"', function(opts) {
'use strict';

var _util = require('lib/util');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

var canvas = parent.opts.canvas;

this.handleWaypointClick = function (e) {
  e.stopPropagation();

  var nodeIds = parent.getSelectedNodeIds();
  var newWaypoint = _waypointsUi2.default.addWaypoint({
    nodeIds: nodeIds,
    title: canvas.store.getNode(nodeIds[0]).title
  });

  var toolsSidebarTag = canvas.toolsSidebarTag;

  if (!toolsSidebarTag.isTabActive('waypoints-tab')) {
    toolsSidebarTag.activateTab({
      tabTagName: 'waypoints-tab',
      push: true
    });
  }

  parent.hide();

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Create-Waypoint',
    label: 'Waypoints'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-create-waypoint')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-create-waypoint.html
// module id = 693
// module chunks = 0